import { Component, OnInit } from '@angular/core';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { DynamicAsset } from '../../models/inModels/DynamicAsset';
import { LazyLoadEvent } from '../../models/DataTables/lazyLoadEvent';
import { Router } from '@angular/router';
import { StorageService } from '../../services/system/storage.service';
import { AssetService } from '../../services/asset.service';
import { DataTable } from 'primeng/primeng';

@Component({
  selector: 'app-asset',
  templateUrl: './asset.component.html',
  styleUrls: ['./asset.component.css']
})
export class AssetComponent implements OnInit {
  loading: boolean;
  messages: Message[];
  asset: DynamicAsset[];
  rows: SelectItem[];
  error: Message[];
  rowEvent: LazyLoadEvent;
  totalRecords: number;
  filteredRecords: number;
  selectedRows: number;
  constructor(    
    private router: Router,
    private confirmationService: ConfirmationService,
    public storageService: StorageService,
    private assetService: AssetService) { 
      this.loading = true;
      this.rows = [];
      this.rows.push({ label: '10', value: 10 });
      this.rows.push({ label: '25', value: 25 });
      this.rows.push({ label: '50', value: 50 });
      this.selectedRows = 10;
    }

  ngOnInit() {
  }

  changeRows(event): void {
    this.loadAssets(this.rowEvent);
  }

  reset(dt: DataTable, gb: HTMLInputElement) {
    gb.value = '';
    dt.reset();
  } 

  
  loadAssets(event: LazyLoadEvent): void {
    this.loading = true;
      event.rows = this.selectedRows;
      this.rowEvent = event;
      this.assetService.search(event).then(
        dataPager => {
          this.asset = dataPager.Data;
          this.filteredRecords = dataPager.FilteredRecords;
          this.totalRecords = dataPager.TotalRecords;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.asset = [];
          this.totalRecords = 0;
          this.filteredRecords = 0;
          this.error = [];
          this.error.push({ severity: 'error', summary: 'Error', detail: error });
        }
      );
  }

  delete(asset: DynamicAsset) {

    this.confirmationService.confirm({
      message: `Are you sure you want to delete ${asset.Name}?`,
      header: 'Confirmation',
      icon: 'fa fa-trash-o',
      accept: () => {
        this.loading = true;
        this.assetService.delete(asset.Id).then(
          result => {
            this.loading = false;
            this.loadAssets(this.rowEvent);
          },
          error => {
            this.loading = false;
            this.error = [];
            this.error.push({ severity: 'error', summary: 'Error', detail: error });
          });
      }
    })
  }

  edit(asset: DynamicAsset) {
		this.router.navigate(['assets/edit', asset.Id]);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/asset/asset.component.ts